import React from "react";
import { Box, Typography } from "@mui/material";

const LogicDesignerPlaceholder: React.FC = () => {
  return (
    
    <Box
      sx={{
        border: "2px dashed #ccc",
        height: 150,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fafafa",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        Logic Designer Coming Soon...
      </Typography>
    </Box>

  );
};

export default LogicDesignerPlaceholder;
